import { defineMessages } from 'react-intl'

export const ORGANIZATION_ORIGIN_TRANSLATIONS = defineMessages({
  northAmerica: {
    id: 'organizationOrigin.northAmerica',
    defaultMessage: 'North America',
  },
  europe: {
    id: 'organizationOrigin.europe',
    defaultMessage: 'Europe',
  },
  easternEurope: {
    id: 'organizationOrigin.easternEurope',
    defaultMessage: 'Eastern Europe',
  },
  asiaPacific: {
    id: 'organizationOrigin.asiaPacific',
    defaultMessage: 'Asia/Pacific',
  },
  southAmerica: {
    id: 'organizationOrigin.southAmerica',
    defaultMessage: 'South America',
  },
  middleEast: {
    id: 'organizationOrigin.middleEast',
    defaultMessage: 'Middle East',
  },
  africa: {
    id: 'organizationOrigin.africa',
    defaultMessage: 'Africa',
  },
  europeRussia: {
    id: 'organizationOrigin.europeRussia',
    defaultMessage: 'Europe/Russia',
  },
})
